export const getPeriodKey = (item) => {
  if (item?.amount) {
    return `amount-${item.amount}`;
  }
  const from = item?.from ?? 0;
  const to = item?.to ?? 0;
  return `from-${from}-to-${to}`;
};

export const formatDisplayPrice = (price) => {
  const num = parseFloat(price);
  if (Number.isNaN(num)) {
    return price;
  }
  return Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
};

export const getHeaderPriceExplanation = (item) => {
  if (item?.priceTextPremiumPackages) {
    return item.priceTextPremiumPackages.trim();
  }
  if (item?.priceText) {
    return item.priceText.replace(/^חיוב חודשי\s*/i, '').trim();
  }
  if (item?.amount) {
    const amount = parseInt(item.amount, 10);
    if (amount === 1) {
      return 'לחודש הראשון';
    }
    return `ל-${amount} החודשים הראשונים`;
  }
  return '';
};

const getPeriodSortOrder = (item) => {
  if (item?.amount) {
    return parseInt(item.amount, 10);
  }
  return parseInt(item?.from, 10) + 1000;
};

const buildBillingRows = (orderPrices, offerName, fullPrice) => {
  const rows = [];

  orderPrices?.forEach((order) => {
    order.offerItemList?.forEach((priceItem) => {
      rows.push({
        key: `offer-${order.cartName}-${getPeriodKey(priceItem)}`,
        label: `${offerName} ${priceItem.priceText || ''}`.trim(),
        price: formatDisplayPrice(priceItem.price),
        isSummary: false,
      });
    });

    order.addonsPrices?.forEach((addon) => {
      addon.priceItemList?.forEach((priceItem) => {
        const addonTitle = addon.title || addon.billDescription || addon.name;
        rows.push({
          key: `addon-${addonTitle}-${getPeriodKey(priceItem)}`,
          label: `${addonTitle} ${priceItem.priceText || ''}`.trim(),
          price: formatDisplayPrice(priceItem.price),
          isSummary: false,
        });
      });
    });
  });

  fullPrice?.forEach((priceItem) => {
    rows.push({
      key: `total-${getPeriodKey(priceItem)}`,
      label: `סה"כ ${priceItem.priceText || ''}`.trim(),
      price: formatDisplayPrice(priceItem.price),
      isSummary: true,
    });
  });

  return rows;
};

const buildOneTimeRows = (oneTimePriceList, totalPriceOneTime) => {
  if (!oneTimePriceList?.length) {
    return [];
  }

  const rows = oneTimePriceList.map((item, index) => ({
    key: `one-time-${index}`,
    label: item.name,
    price: formatDisplayPrice(item.price),
    isSummary: false,
    allowHtml: true,
  }));

  rows.push({
    key: 'one-time-total',
    label: 'סה"כ חיוב חד פעמי',
    price: formatDisplayPrice(totalPriceOneTime),
    isSummary: true,
  });

  return rows;
};

export const buildPackageDetailsViewModel = ({
  packageName,
  offerName,
  shoppingCart,
  oneTimePriceList,
  totalPriceOneTime,
}) => {
  const orderPrices = shoppingCart?.orderPrices;
  const fullPrice = shoppingCart?.fullPrice;
  const oneTimeRows = buildOneTimeRows(oneTimePriceList, totalPriceOneTime);

  if (!fullPrice?.length || !orderPrices?.length) {
    return {
      packageName,
      headerPrice: null,
      headerPriceExplanation: '',
      billingRows: [],
      oneTimeRows,
      isReady: false,
    };
  }

  const sortedTotals = [...fullPrice].sort((a, b) => getPeriodSortOrder(a) - getPeriodSortOrder(b));
  const firstPeriod = sortedTotals[0];
  const billingRows = buildBillingRows(orderPrices, offerName || packageName, fullPrice);

  return {
    packageName,
    headerPrice: formatDisplayPrice(firstPeriod.price),
    headerPriceExplanation: getHeaderPriceExplanation(firstPeriod),
    billingRows,
    oneTimeRows,
    isReady: true,
  };
};
